import React from 'react';

const Company = () => {
  return (
    <div className="a__company">
      <h3 className="b__title-header">会社概要</h3>
      <div className="b__company-info">
        <div className="w__section">
          <div className="header-label">会社名</div>
          <div className="content">FreshSpeed株式会社</div>
        </div>
        <div className="w__section">
          <div className="header-label">代表取締役</div>
          <div className="content">長辻博史</div>
        </div>
        <div className="w__section">
          <div className="header-label">本社</div>
          <div className="content">〒556-0017</div>
          <div className="content">大阪市中央区南船場4丁目12番8-5F</div>
        </div>
        <div className="w__section">
          <div className="header-label">設立</div>
          <div className="content">2017年12月</div>
        </div>
        <div className="w__section">
          <div className="header-label">事業内容</div>
          <div className="content">オークションサイトの運営</div>
        </div>
        <div className="w__section">
          <div className="header-label">顧問</div>
          <div className="content">
            <a
              href="https://www.police.jp.net/"
              rel="noopener noreferrer"
              target="_blank"
            >
              警ゆう支援合同会社
            </a>
          </div>
          <div className="content">
            <a
              href="https://www.leadz.jp/"
              rel="noopener noreferrer"
              target="_blank"
            >
              リーズ法律事務所
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Company;
